<template>
  <div v-if='label'>
    <span
      class='relative mx-auto flex w-fit items-center justify-center rounded transition-colors duration-200'
      :class='[badgeStyles, hover && hoverStyles]'
      :style='"color:" + color + ";"'
      style='max-height: 24px;'
    >
      <div
        class='absolute z-[1] h-full w-full rounded opacity-25'
        :style='"background-color:" + color + ";"'
      />
      <div class='relative z-[2] inline-flex items-center'>
        <svg
          v-if='dotted'
          :class='[dotStyles]'
          class='mr-1.5'
          fill='currentColor'
          viewBox='0 0 8 8'
        >
          <circle
            cx='4'
            cy='4'
            r='3'
          />
        </svg>
        <span :class='["text-center text-xs font-medium brightness-[70%] lg:text-sm", { capitalize }]'>{{ label }}</span>
      </div>
    </span>
    <span
      :class='[
        "bg-pink-100", "bg-blue-100", "bg-green-100", "bg-red-100", "bg-rose-100", "bg-orange-100", "bg-yellow-100", "bg-sky-100", "bg-indigo-100", "bg-gray-100",
        "hover:bg-red-300","hover:text-red-100",
        "text-pink-400", "text-blue-400", "text-green-400", "text-red-400", "text-rose-400", "text-orange-400", "text-yellow-400", "text-sky-400", "text-indigo-400", "text-gray-400",
        "text-pink-800", "text-blue-800", "text-green-800", "text-red-800", "text-rose-800", "text-orange-800", "text-yellow-800", "text-sky-800", "text-indigo-800", "text-gray-800"]'
    />
  </div>
</template>

<script lang="ts">
  import { defineComponent, computed } from 'vue'

  export default defineComponent({
    name: 'BadgeComponent',
    props: {
      label: {
        type: String,
        default: null,
      },
      dotted: {
        type: Boolean,
        default: false,
      },
      rounded: {
        type: String,
        default: 'md',
      },
      size: {
        type: String,
        default: 'md',
      },
      color: {
        type: String,
        default: 'indigo',
      },
      hover: {
        type: Boolean,
        default: false,
      },
      capitalize: {
        type: Boolean,
        default: true,
      },
    },
    setup(props) {
      const badgeStyles = computed(() => {
        let classes = 'flex items-center py-1 '

        switch (props.size) {
        case 'md':
          classes += 'px-2.5 py-0.5 text-xs '
          break
        case 'lg':
          classes += 'px-3 py-0.5 text-sm '
          break
        }

        switch (props.rounded) {
        case 'md':
          classes += 'rounded '
          break
        case 'lg':
          classes += 'rounded-full '
          break
        }

        classes += 'bg-' + props.color + '-100 text-' + props.color + '-800'

        return classes
      })

      const dotStyles = computed(() => {
        let classes = 'r-1.5 h-2 w-2 '

        switch (props.size) {
        case 'md':
          classes += '-ml-0.5 '
          break
        case 'lg':
          classes += '-ml-1 '
          break
        }

        classes += 'text-' + props.color + '-400'

        return classes
      })

      const hoverStyles = computed(() => {
        return 'hover:bg-' + props.color + '-300 hover:text-' + props.color + '-100'
      })

      return {
        badgeStyles,
        dotStyles,
        hoverStyles,
      }
    },
  })
</script>
